module.exports = __webpack_public_path__ + "static/media/lead-hawk-ai-logo.364bee1c.png";